module.exports = __webpack_public_path__ + "img/anf6.63638da0.png";